import { render } from "./MessageUser.vue?vue&type=template&id=e89c45b8&scoped=true"
import script from "./MessageUser.vue?vue&type=script&lang=js"
export * from "./MessageUser.vue?vue&type=script&lang=js"

import "./MessageUser.vue?vue&type=style&index=0&id=e89c45b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e89c45b8"]])

export default __exports__